var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-selector',{attrs:{"filterable":false,"options":_vm.caseStatusList,"remote":_vm.caseStatusSearch},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d43c6cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness-select/CaseStatusSelector.vue
// module id = null
// module chunks = 